import { SHORT_DATE_TIME_FORMAT } from 'constants/dates';
import { IPodData, IPodDataSimlified } from 'services/pod/types';
import { getFormattedDate } from 'utils/dates';

export const convertSimplifiedToPodData = (data: IPodDataSimlified): IPodData => ({
  TicketId: 0,
  TicketNumber: '',
  ContactId: data.id,
  CompanyId: data.companyId,
  CompanyName: data.companyName,
  ContactName: data.name,
  ContactInitials: '',
  ContactPhone: data.phone ?? '',
  ContactEmail: data.email ?? '',
  isVerified: data.isVerified,
  optedStatus: data.optedStatus,
  teamsUserEmail: data.teamsUserEmail,
  msTenantHasOnboarded: data.msTenantHasOnboarded,
  duoHasOnboarded: data.duoHasOnboarded,
  clientPortalChats: [],
  communicationItems: data.communicationItems.map(item => ({
    Name: item.name,
    Type: item.type,
    Value: item.value,
    IsVerified: item.isVerified,
  })),
  history: data.history.map(item => ({
    Date: getFormattedDate(item.date, SHORT_DATE_TIME_FORMAT),
    Item: item.item ?? '',
    Type: item.type,
    Inspector: item.inspector,
    Notes: item.notes,
    IsRevoked: item.isRevoked,
  })),
});

/**
 * The pod stores TicketId 0 when it was opened without a ticket (contact or company screen);
 * that is the only "no ticket" sentinel this app writes. IPodData types TicketId as `number`,
 * but the backend's TicketInfoLightModel.TicketId is a string, and it is not always numeric -
 * ServiceNow's is a hex sys_id (e.g. "62826bf03710200044e0bfc8bcbe5df1"). Comparing with `> 0`
 * would coerce that to NaN and silently drop a real ticket id, so this checks identity with the
 * sentinel instead of the value's shape.
 */
export const getPodTicketId = (
  podData: Pick<Partial<IPodData>, 'TicketId'>,
): IPodData['TicketId'] | undefined => (podData.TicketId === 0 ? undefined : podData.TicketId);
